// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"8fa875ad","88":"9974a417","331":"31390a7c","831":"a818ad6e","859":"deddfd74","895":"ba8ec3c6"}[chunkId] + ".chunk.css";
};